export function poorNetMsg (count) {
  return `${count} resources have failed to be delivered. You may need to re-do the last action or re-load the page.
If the issue persists, please contact the network administrators.`;
}

export const badNetTitle = 'Poor network quality detected';

export const websocketsAreUnstableMsg = 'Websockets are unstable. If the issue persists, please contact the network administrators.';

export const toastMessagesReducerKey = 'ToastMessages';

export const newToastMessageType = 'NEW_TOAST_MESSAGE_TYPE';
export const removeToastMessageType = 'REMOVE_TOAST_MESSAGE_TYPE';
export const setRemovingToastMessageType = 'SET_REMOVING_TOAST_MESSAGE_TYPE';
export const updateToastMessageType = 'UPDATE_TOAST_MESSAGE_TYPE';
